import qualifyLink from './linkQualifier';

class FetchError extends Error {
    constructor(res, message, retry = true) {

        super(message);

        this.name = 'FetchError';
        this.response = res;
        this.retry = retry;
        
        Error.captureStackTrace(this, FetchError);
    }
}

export default async function fetchHelper(url, options) {
    const defaults = {
        headers: {
            'X-REQUESTED-WITH': 'XMLHttpRequest',
            'Content-Type': 'application/json'
        },
        credentials: 'same-origin' //'include'
    };

    let deepCopyOptions = JSON.parse(JSON.stringify(options || {}));
    if (deepCopyOptions.headers) {
        deepCopyOptions.headers['X-REQUESTED-WITH'] = defaults.headers['X-REQUESTED-WITH'];
        deepCopyOptions.headers['Content-Type'] =  defaults.headers['Content-Type'];
    } else {
        deepCopyOptions.headers = defaults.headers;
    }
    deepCopyOptions.credentials = defaults.credentials;

    const uri = qualifyLink(url);

    const response = await fetch(uri, deepCopyOptions);
    if (response.status === 403) {
        window.location.replace(qualifyLink('/myace/'));
        return Promise.reject(new FetchError(response, 'Unauthorized Access.', false))
    }
    let failHeader = response.headers.get('X-Responded-JSON');
    if (failHeader) {
        let failObj = JSON.parse(failHeader);
        if (failObj.status === 401) {
            let redirectUri = qualifyLink('/myace/login/?ReturnUrl=' + encodeURIComponent(window.location.href));
            window.location.replace(redirectUri);
            return Promise.reject(new FetchError(failObj, 'Unauthenticated Access.', false));
        }
    }
    if (!response.ok) {
        return Promise.reject(new FetchError(response, response.statusText));
    }
    return response;
}